import styled from "styled-components";
import { useState, useEffect } from "react";
import PrimaryButton from "../../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../../components/FormControls/SecondaryButton";
import request from "../../../../../../api/request";
import Grid from "../../../../../../components/Grid";
import { NotificationManager } from 'react-notifications';
import FormSelectWithLabel from "../../../../../../components/FormControls/FormSelectWithLabel";
import FormCheckBox from "../../../../../../components/FormControls/FormCheckBox";
import FormStringInput from "../../../../../../components/FormControls/FormStringInput";
import FormCheckBoxWithRightLabel from "../../../../../../components/FormControls/FormCheckBoxWithRightLabel";

const StyledUserRulesSettings = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 600px;
    box-sizing: border-box;
    min-height: 526px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

function UserRulesSettings(props) {

    const {selectedUser, branches, festivals} = props;

    const [loadedPage, setLoadedPage] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeletingUserRule, setIsDeletingUserRule] = useState(false);
    const [userRules, setUserRules] = useState([]);
    const [selectedUserRule, setSelectedUserRule] = useState(null);
    const [selectedUserRuleId, setSelectedUserRuleId] = useState(null);
    const [isAddUserRuleMode, setIsAddUserRuleMode] = useState(false);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Branch', type: 'String', width: 100, textAlign: 'left'},
        {id: 'Sub-branch', type: 'String', width: 80, textAlign: 'center'},
        {id: 'Festival', type: 'String', width: 60, textAlign: 'center'},
    ]);
    const [gridData, setGridData] = useState({groups: [''], items: [[]]});

    const [recordType, setRecordType] = useState(1);
    const [branchName, setBranchName] = useState('');
    const [isTreasurer, setIsTreasurer] = useState(false);
    const [isAuditor, setIsAuditor] = useState(false);
    const [isViewer, setIsViewer] = useState(false);
    const [isOfficer, setIsOfficer] = useState(false);
    const [isFestivalTreasurer, setIsFestivalTreasurer] = useState(false);
    const [isOrganiser, steIsOrganiser] = useState(false);
    const [festivalName, setFestivalName] = useState('');
    
    const [needsValidation, setNeedsValidation] = useState(false);
    const [isAddingDuplicatedUserRule, setIsAddingDuplicatedUserRule] = useState(false);

    const [festivalList, setFestivalList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    
    let branchTypes = ['Branch', 'Sub-Branch'];
    const branchTypeStringToInt = (branchTypeStr) => {
        if (branchTypeStr === 'Branch') {
            return 1;
        } else {
            return 2;
        }
    }
    const onChangeBranchType = (e) => {
        let bType = branchTypeStringToInt(e.target.value);
        setRecordType(bType);
    }

    const onSelectGridItem = (item) => {
        setSelectedUserRuleId(item.Id);
        setSelectedUserRule(item);
    }
    
    const fetchUserRules = async (branchCommitteeCodeToSelect) => {
        try {
            let userRuleList = [];

            const resp = (await request('database', 'fetchUserRules'));
            if (resp.ok) {
                resp.data.map((userRule, index) => {
                    userRuleList.push(userRule);
                });
                setUserRules(userRuleList);
                rebuildGridData(userRuleList, branchCommitteeCodeToSelect);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch user rules: ', e);
            return false;
        }
        return true;
    }

    const getBranchFromBranchName = (recordType, branchName) => {
        if (branches.length > 0) {
            for (let i = 0; i < branches.length; i ++) {
                if (branches[i].RecordType === recordType && branches[i].RecordName === branchName) {
                    return branches[i];
                }
            }
        }
        return null;
    }

    const getBranchFromBranchCommitteeCode = (recordType, branchCommitteeCode) => {
        if (branches.length > 0) {
            for (let i = 0; i < branches.length; i ++) {
                if (branches[i].RecordType === recordType && branches[i].BranchCommitteeCode === branchCommitteeCode) {
                    return branches[i];
                }
            }
        }
        return null;
    }

    const getFestivalFromFestivalName = (recordType, branchCommitteeCode, divisionCode, festivalName) => {
        if (festivals.length > 0) {
            for (let i = 0; i < festivals.length; i ++) {
                if (festivals[i].RecordType === recordType && festivals[i].BranchCommitteeCode === branchCommitteeCode && festivals[i].DivisionCode === divisionCode && festivals[i].RestrictedFundName === festivalName) {
                    return festivals[i];
                }
            }
        }
        return null;
    }

    const getFestivalFromFestivalCode = (recordType, branchCommitteeCode, divisionCode, festivalCode) => {
        if (festivals.length > 0) {
            for (let i = 0; i < festivals.length; i ++) {
                if (festivals[i].RecordType === recordType && festivals[i].BranchCommitteeCode === branchCommitteeCode && festivals[i].DivisionCode === divisionCode && festivals[i].RestrictedFundCode === festivalCode) {
                    return festivals[i];
                }
            }
        }
        return null;
    }

    const onDeleteUserRule = async () => {
        if (selectedUserRule) {
            setIsDeletingUserRule(true);
            let userRuleData = {};
            userRuleData.UserName = selectedUser.UserName;
            userRuleData.BranchCommitteeCode = selectedUserRule.BranchCommitteeCode;
            userRuleData.EarmarkedFundCode = selectedUserRule.EarmarkedFundCode;

            const resp = (await request('database', 'deleteUserRule', [userRuleData]));
            if (resp.ok) {
                setSelectedUserRule(null);
                setSelectedUserRuleId(null);
                fetchUserRules(selectedUser.BranchCommitteeCode);
                NotificationManager.success('Successfully deleted user rule');
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsDeletingUserRule(false);
        }
    }

    const onSaveChanges = async () => {
        if (isAddUserRuleMode) { // adding new item
            if (branchName === '' || branchName === null || branchName === 'None') {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                let selectedBranch = getBranchFromBranchName(recordType, branchName);
                let selectedFestival = selectedBranch ? getFestivalFromFestivalName(recordType, selectedBranch.BranchCommitteeCode, selectedBranch.DivisionCode, festivalName) : null;
                if (gridData.items[0].length > 0 && (gridData.items[0].find((itm) => itm.RecordType === recordType && itm.BranchCommitteeCode.replace(/\s/g, '') === selectedBranch.BranchCommitteeCode && (selectedFestival !== null && itm.EarmarkedFundCode === selectedFestival.RestrictedFundCode || (itm.EarmarkedFundCode === null && selectedFestival === null))))) {
                    setIsAddingDuplicatedUserRule(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.UserName = selectedUser.UserName;
                    saveData.RecordType = recordType;
                    saveData.BranchCommitteeCode = getBranchFromBranchName(recordType, branchName).BranchCommitteeCode;
                    saveData.DivisionCode = getBranchFromBranchName(recordType, branchName).DivisionCode;
                    saveData.IsTreasurer = isTreasurer;
                    saveData.IsAuditor = isAuditor;
                    saveData.IsViewer = isViewer;
                    saveData.IsOfficer = isOfficer;
                    saveData.IsFestivalTreasurer = isFestivalTreasurer;
                    saveData.IsOrganiser = isOrganiser;

                    let selectedBranch = getBranchFromBranchName(recordType, branchName);
                    let selectedFestival = selectedBranch ? getFestivalFromFestivalName(recordType, selectedBranch.BranchCommitteeCode, selectedBranch.DivisionCode, festivalName) : null;
                    saveData.EarmarkedFundCode = selectedFestival ? selectedFestival.RestrictedFundCode : null;

                    const resp = (await request('database', 'createUserRule', [saveData]));
                    if (resp.ok) {
                        fetchUserRules(selectedBranch.BranchCommitteeCode);
                        NotificationManager.success('Successfully added user rule');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddUserRuleMode(false);
                }
            }
        } else {
            if (branchName === '' || branchName === null || branchName === 'None') {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                setIsSaving(true);
                let saveData = {};
                saveData.UserName = selectedUser.UserName;
                saveData.RecordType = recordType;
                saveData.BranchCommitteeCode = getBranchFromBranchName(recordType, branchName).BranchCommitteeCode;
                saveData.DivisionCode = getBranchFromBranchName(recordType, branchName).DivisionCode;
                saveData.IsTreasurer = isTreasurer;
                saveData.IsAuditor = isAuditor;
                saveData.IsViewer = isViewer;
                saveData.IsOfficer = isOfficer;
                saveData.IsFestivalTreasurer = isFestivalTreasurer;
                saveData.IsOrganiser = isOrganiser;

                let selectedBranch = getBranchFromBranchName(recordType, branchName);
                let selectedFestival = selectedBranch ? getFestivalFromFestivalName(recordType, selectedBranch.BranchCommitteeCode, selectedBranch.DivisionCode, festivalName) : null;
                saveData.EarmarkedFundCode = selectedFestival ? selectedFestival.RestrictedFundCode : null;
                
                saveData.OldBranchCommitteeCode = selectedUserRule.BranchCommitteeCode;
                saveData.OldEarmarkedFundCode = selectedUserRule.EarmarkedFundCode;

                const resp = (await request('database', 'updateUserRule', [saveData]));
                if (resp.ok) {
                    fetchUserRules(selectedBranch.BranchCommitteeCode);
                    NotificationManager.success('Successfully updated user rule');
                } else
                {
                    console.log(resp.data);
                    NotificationManager.error(resp.data);
                }
                setIsSaving(false);
            }
        }
    }

    const rebuildGridData = (userRules, branchCommitteeCodeToSelect) => {
        if (userRules && selectedUser && userRules.length > 0) {
            let userRuleList = [];
            userRules.map((userRule, index) => {
                if (userRule.UserName === selectedUser.UserName) {
                    let gridItem = {Id: index, Branch: getBranchFromBranchCommitteeCode(userRule.RecordType, userRule.BranchCommitteeCode).RecordName, 'Sub-branch': getBranchFromBranchCommitteeCode(userRule.RecordType, userRule.BranchCommitteeCode).DivisionCode, Festival: userRule.EarmarkedFundCode ? userRule.EarmarkedFundCode : '', ...userRule};
                    userRuleList.push(gridItem);
                    if (branchCommitteeCodeToSelect && userRule.BranchCommitteeCode === branchCommitteeCodeToSelect) {
                        setSelectedUserRuleId(index);
                        setSelectedUserRule(gridItem);
                    }
                }
            });
            setGridData({groups: [''], items: [userRuleList]});
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            fetchUserRules();
            setLoadedPage(true);
        }

        rebuildGridData(userRules);

        setRecordType(1);
        setBranchName(null);
        setIsTreasurer(false);
        setIsViewer(false);
        setIsAuditor(false);
        setIsOfficer(false);
        setIsFestivalTreasurer(false);
        steIsOrganiser(false);
        setFestivalName(null);

        setSelectedUserRule(null);
        setSelectedUserRuleId(null);
        setNeedsValidation(false);
    }, [selectedUser]);

    useEffect(() => {
        if (isAddUserRuleMode) {
            setNeedsValidation(false);
            setRecordType(1);
            setBranchName(null);
            setIsTreasurer(false);
            setIsViewer(false);
            setIsAuditor(false);
            setIsOfficer(false);
            setIsFestivalTreasurer(false);
            steIsOrganiser(false);
            setFestivalName(null);
        } else if (selectedUserRule) {
            setNeedsValidation(false);
            setRecordType(selectedUserRule.RecordType);
            setBranchName(selectedUserRule.Branch);
            setIsTreasurer(selectedUserRule.IsTreasurer);
            setIsViewer(selectedUserRule.IsViewer);
            setIsAuditor(selectedUserRule.IsAuditor);
            setIsOfficer(selectedUserRule.IsOfficer);
            setIsFestivalTreasurer(selectedUserRule.IsFestivalTreasurer);
            steIsOrganiser(selectedUserRule.IsOrganiser);
            let branch = getBranchFromBranchCommitteeCode(selectedUserRule.RecordType, selectedUserRule.BranchCommitteeCode);
            let festival = getFestivalFromFestivalCode(branch.RecordType, branch.BranchCommitteeCode, branch.DivisionCode, selectedUserRule.EarmarkedFundCode);
            setFestivalName(festival ? festival.RestrictedFundName : null);
        }
    }, [isAddUserRuleMode]);

    useEffect(() => {
        if (selectedUserRule) {
            setRecordType(selectedUserRule.RecordType);
            setBranchName(selectedUserRule.Branch);
            setIsTreasurer(selectedUserRule.IsTreasurer);
            setIsViewer(selectedUserRule.IsViewer);
            setIsAuditor(selectedUserRule.IsAuditor);
            setIsOfficer(selectedUserRule.IsOfficer);
            setIsFestivalTreasurer(selectedUserRule.IsFestivalTreasurer);
            steIsOrganiser(selectedUserRule.IsOrganiser);
            let branch = getBranchFromBranchCommitteeCode(selectedUserRule.RecordType, selectedUserRule.BranchCommitteeCode);
            let festival = getFestivalFromFestivalCode(branch.RecordType, branch.BranchCommitteeCode, branch.DivisionCode, selectedUserRule.EarmarkedFundCode);
            setFestivalName(festival ? festival.RestrictedFundName : null);
        } else {
            setNeedsValidation(false);
            setRecordType(1);
            setBranchName(null);
            setIsTreasurer(false);
            setIsViewer(false);
            setIsAuditor(false);
            setIsOfficer(false);
            setIsFestivalTreasurer(false);
            steIsOrganiser(false);
            setFestivalName(null);
        }
    }, [selectedUserRule]);

    useEffect(() => {
        if (branches.length > 0) {
            let list = [];
            branches.map((b) => {
                if (b.RecordType === recordType) {
                    list.push(b.RecordName);
                }
            });
            setBranchList(list);
        }
    }, [recordType]);

    useEffect(() => {
        let selectedBranch = getBranchFromBranchName(recordType, branchName);
        if (festivals.length > 0 && selectedBranch) {
            let list = [];
            festivals.map((f) => {
                if (f.RecordType === selectedBranch.RecordType && f.BranchCommitteeCode === selectedBranch.BranchCommitteeCode && f.DivisionCode === selectedBranch.DivisionCode) {
                    list.push(f.RestrictedFundName);
                }
            });
            setFestivalList(list);
        } else {
            setFestivalList([]);
        }

        setIsAddingDuplicatedUserRule(false);
    }, [branchName, selectedUser]);

    useEffect(() => {
        setIsAddingDuplicatedUserRule(false);
    }, [festivalName]);

    useEffect(() => {
        setIsAddingDuplicatedUserRule(false);
        setNeedsValidation(false);
    }, [selectedUser, selectedUserRule, isAddUserRuleMode]);

    return (
        <StyledUserRulesSettings>
            <WhiteBoard>
                <div style={{display:'flex'}}>
                    <div>
                        <Grid id='usersetting_userrules_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddUserRuleMode} itemIdToSelect={selectedUserRuleId} onSelectGridItem={onSelectGridItem} gridStyle={{width:240, height:400}} fontSize={11}></Grid>
                        <div style={{marginTop:20}}>
                            {selectedUserRule && !isAddUserRuleMode && <SecondaryButton caption='Delete' isLoading={isDeletingUserRule} onClick={() => onDeleteUserRule()} style={{width:75, height:25}}></SecondaryButton>}
                            {isAddUserRuleMode && <SecondaryButton caption='Cancel' onClick={() => setIsAddUserRuleMode(false)} style={{width:75, height:25, float:'right'}}></SecondaryButton>}
                            {!isAddUserRuleMode && <PrimaryButton caption='Create new' onClick={() => setIsAddUserRuleMode(true)} style={{width:100, height:25, float:'right'}}></PrimaryButton>}
                        </div>
                    </div>
                    <div style={{marginLeft:30}}>
                        <Title>User rules</Title>
                        <FormSelectWithLabel label='Type' items={branchTypes} value={branchTypes[recordType-1]} onChange={(e) => onChangeBranchType(e)} style={{width:260, height:35, paddingLeft:13}}></FormSelectWithLabel>
                        <FormSelectWithLabel label='Branch' items={['None', ...branchList]} value={branchName ? branchName : 'None'} validated={needsValidation && branchName === null ? false : undefined} onChange={(e) => setBranchName(e.target.value === 'None' ? null : e.target.value)} style={{width:260, height:35, paddingLeft:13}}></FormSelectWithLabel>

                        <Title style={{marginTop:20}}>User roles</Title>
                        <FormCheckBoxWithRightLabel label='Treasurer' checked={isTreasurer} onCheck={(val) => setIsTreasurer(val)} style={{marginTop:0}}></FormCheckBoxWithRightLabel>
                        <FormCheckBoxWithRightLabel label='Viewer' checked={isViewer} onCheck={(val) => setIsViewer(val)} style={{paddingTop:12}}></FormCheckBoxWithRightLabel>
                        <FormCheckBoxWithRightLabel label='Auditor / Examiner' checked={isAuditor} onCheck={(val) => setIsAuditor(val)} style={{paddingTop:12}}></FormCheckBoxWithRightLabel>
                        <FormCheckBoxWithRightLabel label='Regional Finance Officer' checked={isOfficer} onCheck={(val) => setIsOfficer(val)} style={{paddingTop:12}}></FormCheckBoxWithRightLabel>
                        <FormCheckBoxWithRightLabel label='Festival Treasurer' checked={isFestivalTreasurer} onCheck={(val) => setIsFestivalTreasurer(val)} style={{paddingTop:20}}></FormCheckBoxWithRightLabel>
                        <FormCheckBoxWithRightLabel label='Branch Festival Organiser' checked={isOrganiser} onCheck={(val) => steIsOrganiser(val)} style={{paddingTop:12}}></FormCheckBoxWithRightLabel>

                        <FormSelectWithLabel label='Festival' items={['None', ...festivalList]} value={festivalName ? festivalName : 'None'} disabled={!isFestivalTreasurer} onChange={(e) => setFestivalName(e.target.value === 'None' ? null : e.target.value)} style={{width:260, height:35, paddingLeft:13}}></FormSelectWithLabel>
                        {isAddingDuplicatedUserRule && <div style={{marginTop:5, width:280, fontSize:12, fontWeight:700, color:'#dc3545'}}>* Branch and festival is duplicated.</div>}
                    </div>
                </div>
            </WhiteBoard>
            <div>
                <PrimaryButton caption={isAddUserRuleMode ? 'Add user rule' : 'Save changes'} isLoading={isSaving} onClick={() => onSaveChanges()} disabled={isAddUserRuleMode || selectedUserRule ? false : true} style={{width:150, float:'right'}}></PrimaryButton>
            </div>
        </StyledUserRulesSettings>
    )
}

export default UserRulesSettings;